import { iconImages } from './iconMap';
import { CARD_ICONS } from './cardConstants';

/**
 * Animates a card moving from its current position to a slot
 * @param sourceElement - The source DOM element
 * @param cardType - The type of card being animated
 * @param slotsRef - Reference to the slots container
 * @param onComplete - Function to call when animation completes
 */
export const animateCardToSlot = (
  sourceElement: Element, 
  cardType: number, 
  slotsRef: React.RefObject<HTMLDivElement | null>,
  onComplete: () => void
) => {
  // Get source and target positions
  const sourceRect = sourceElement.getBoundingClientRect();
  const slotRect = slotsRef.current?.getBoundingClientRect();

  if (!slotRect) {
    onComplete();
    return;
  }

  // Calculate next slot position (approximation for animation)
  const nextSlotIndex = document.querySelectorAll('.slot-card').length;
  const targetX = slotRect.left + (nextSlotIndex * 85) + 35;
  const targetY = slotRect.top + 35;

  // Create flying element
  const flyingEl = document.createElement('div');
  flyingEl.className = 'flying-card';
  
  // Create inner elements
  const innerEl = document.createElement('div');
  innerEl.className = 'card-inner';
  
  const iconEl = document.createElement('div');
  const iconType = CARD_ICONS[cardType];
  iconEl.className = `card-icon ${iconType}`;
  
  // Create image element
  const imgEl = document.createElement('img');
  imgEl.src = iconImages[iconType];
  imgEl.alt = iconType;
  imgEl.className = 'flying-card-icon-image';
  
  // Assemble elements
  iconEl.appendChild(imgEl);
  innerEl.appendChild(iconEl);
  flyingEl.appendChild(innerEl);
  
  // Set initial position
  flyingEl.style.left = `${sourceRect.left}px`;
  flyingEl.style.top = `${sourceRect.top}px`;
  flyingEl.style.width = `${sourceRect.width}px`;
  flyingEl.style.height = `${sourceRect.height}px`;
  
  // Add to document
  document.body.appendChild(flyingEl);
  
  // Force reflow to ensure initial position is set
  flyingEl.getBoundingClientRect();
  
  // Apply direct linear transition with no bezier curve to avoid rightward detour
  flyingEl.style.transition = 'all 200ms linear';
  flyingEl.style.transform = `translate(${targetX - sourceRect.left}px, ${targetY - sourceRect.top}px)`;
  
  // Cleanup after animation
  setTimeout(() => {
    document.body.removeChild(flyingEl);
    onComplete();
  }, 200);
}; 